import { AppStore } from './store'
import { retrieveHistoricalActions } from 'storage/historicalActions'
import { RESTORE_HISTORICAL_ACTIONS } from 'actions/actionConstants'

function initialiseHistoricalActions(store: AppStore): void {
  const storedHistoricalActions = retrieveHistoricalActions()
  if (storedHistoricalActions && storedHistoricalActions.length > 0) {
    store.dispatch({
      type: RESTORE_HISTORICAL_ACTIONS,
      actions: storedHistoricalActions,
    })
  }
}

export default initialiseHistoricalActions
